import { Navigate } from 'react-router-dom'

export default function ProspectLanding() {
  return <Navigate to="/portal/prospect" replace />
}
